// extracted by mini-css-extract-plugin
export var orderSummary = "_qk-0";
export var showMoreLessButton = "_qk-1";